export function loadModelViewer() {
  if (window.customElements?.get("model-viewer")) return; // schon geladen

  const script = document.createElement("script");
  script.type = "module";
  script.src = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
  document.head.appendChild(script);
}